import { getLogString } from "../Utils/utils"

export const getters = {
  getScores: (state) => {
    return state.scoreTable
  },
  getPlayers: (state) => {
    return state.players.slice(0, state.numPlayers)
  },
  getCurrent: (state) => {
    return state.current
  },
  getCurrentCount: (state) => {
    return state.currentCount
  },
  getPassingSequence: (state) => {
    if (state.players?.length > 0) {
      return state.passingSequence.map((x) => ({ name: state.players[x].name || x + 1, emptySeat: state.players[x].emptySeat }));
    } else {
      return []
    }
  },
  getOnDirect: (state) => {
    return state.onDirect;
  },
  getGameNotes: (state) => {
    return state.gameNotes;
  },
  getDisplayTime: (state) => {
    return state.timer.displayTime
    // if (state.timer.timer) {
    //   return state.timer.displayTime;
    // } else {
    //   return state.onDirect ? state.timer.directTime : state.timer.passTime;
    // }
  },
  getCurrentQuestion: (state) => {
    if (state.questionDisplayMode === "Answer") {
      return state.questionsList[state.peekAnswer ? state.currentQuestionNo : state.currentQuestionNo - 1]
    }
    return state.questionsList[state.currentQuestionNo]
  },
  getPostMessageBody: (state) => {
    return {
      numPlayers: state.numPlayers,
      numRounds: state.numRounds,
      numDirects: state.numDirects,
      gameId: state.gameId,
      gameType: state.gameType,
      finishGame: state.finishGame,
      fileName: state.fileName,
      players: state.players,
      scoreTable: state.scoreTable,
      readerName: state.readerName,
      gamePlayString: state.gamePlayString,
      gameStartTime: state.gameStartTime,
      currentQuestionNo: state.currentQuestionNo,
      gameNotes: state.gameNotes,
      leagueName: state.leagueName,
      leagueSeason: state.leagueSeason,
      gameWeek: state.gameWeek,
      matchNumber: state.matchNumber,
      leagueMatch: state.leagueMatch,
      freeDirect: state.freeDirect
    }
  },
  getPostGameLogBody: (state) => {
    return {
      fileName: state.fileName,
      encryptedText: getLogString(state.log),
      gameType: 'mimir'
    }
  },
  getWikiQuizUrl: (state) => {
    let returnUrl = "https://wikiquiz.org/Quiz_Scorer_App.html#/!/IQM";
    returnUrl += `/${state.leagueName ? encodeURI(state.leagueName) : ''}//${state.leagueSeason || ''}/${state.matchNumber || ''}/${encodeURI(state.readerName)}///${state.numPlayers}`;
    state.players.forEach((p) => {
      returnUrl += `/${encodeURI(p.name)}`;
    });
    returnUrl += "/".repeat(40 - parseInt(state.numPlayers));
    returnUrl += `/${state.numRounds}/${state.numDirects}`;
    returnUrl += `/${encodeURI(state.gameStartTime)}/`;
    returnUrl += `/${state.gamePlayString.length}/${state.gamePlayString}`;

    return returnUrl;
  },
  getFilledSeats: (state) => {
    return state.players.filter(x => !x.emptySeat).length
  },
  getSelfReadSwitch: state => state.selfReadSwitch,
  allPlayersEmpty: state => {
    return state.players.every(p => !p.name)
  }
}